import * as React from "react";
import PropTypes from "prop-types";
import DefaultLayout from "../../Layouts/DefaultLayout";
import SettingsArtus from "../../Components/SettingsArtus";
import Header from "../../Containers/Header";
import Visualization2D from "../../Components/Visualization2D";
import SaveConfiguration from "../../Containers/SaveConfiguration";
import LoadConfiguration from "../../Containers/LoadConfiguration";
import SendEmail from "../../Containers/SendEmail";
import PdfDownload from "../../Containers/PdfDownload";
import { useDispatch, useSelector } from "react-redux";
import get from "lodash/get";
import {
  getConfiguration,
  getConfigurationByCode,
  loadOptions,
  setLoadCode,
} from "../../reducers/Configuration/Actions";
import { useEffect } from "react";
import AddToCart from "../../Components/AddToCart";
import VisualizationIsoWarehouse from "../../Components/VisualizationIsoWarehouse";
import VisualizationIsoArchive from "../../Components/VisualizationIsoArchive";
import SettingsBertArchive from "../../Components/SettingsBertArchive";
import SettingsBertWarehouse from "../../Components/SettingsBertWarehouse";
import qs from "qs";
import Api from "../../core/Api";
import { storeUserData } from "../../reducers/User/Actions";
import { identifiers } from "../../core/Constants";

export function ConfiguratorScreen(props) {
  const {
    renderHeader,
    Layout,
    renderSaveConfiguration,
    renderSendEmail,
    renderPdfDownload,
    renderLoadConfiguration,
    renderAddToCart,
  } = props;
  const dispatch = useDispatch();
  const params = {};
  const itemRegex = new RegExp(`/(code|identifier):([^/]+)`);
  const results = itemRegex.exec(location.pathname);
  if (results) {
    params[results[1]] = results[2];
  }
  const configuration = useSelector((state) => {
    return state.Configuration.configuration;
  });
  const { bertArchiveComponentOptions, artusComponentOptions, bertWarehouseComponentOptions } = useSelector(
    (state) => {
      return state.Configuration;
    }
  );
  const itemIdentifier = get(configuration, "item.identifier", null);

  useEffect(() => {
    if (params.code) {
      dispatch(setLoadCode(params.code));
      dispatch(getConfigurationByCode(params.code));
    } else if (params.identifier) {
      dispatch(getConfiguration(identifiers[params.identifier]));
    }
  }, []);

  useEffect(() => {
    if (configuration && itemIdentifier) {
      const options =
        itemIdentifier === "artus"
          ? artusComponentOptions
          : itemIdentifier === "bertWarehouse"
          ? bertWarehouseComponentOptions
          : bertArchiveComponentOptions;
      options.map(
        (classification) =>
          classification.options.length === 0 &&
          dispatch(loadOptions(itemIdentifier, classification.key, classification.identifier))
      );
    }
  }, [configuration]);
  return (
    <Layout
      renderHeader={() => renderHeader()}
      renderSaveConfiguration={() => renderSaveConfiguration()}
      renderLoadConfiguration={() => renderLoadConfiguration()}
      renderSendEmail={() => renderSendEmail()}
      renderPdfDownload={() => renderPdfDownload()}
      renderSettings={() =>
        itemIdentifier ? (
          itemIdentifier === "artus" ? (
            <SettingsArtus />
          ) : itemIdentifier === "bertWarehouse" ? (
            <SettingsBertWarehouse />
          ) : (
            <SettingsBertArchive />
          )
        ) : null
      }
      renderVisualization={() =>
        itemIdentifier ? (
          itemIdentifier === "artus" ? (
            <Visualization2D />
          ) : itemIdentifier === "bertWarehouse" ? (
            <VisualizationIsoWarehouse />
          ) : (
            <VisualizationIsoArchive />
          )
        ) : null
      }
      renderAddToCart={() => renderAddToCart()}
    />
  );
}

ConfiguratorScreen.propTypes = {
  renderHeader: PropTypes.func,
  Layout: PropTypes.elementType.isRequired,
};

ConfiguratorScreen.defaultProps = {
  renderHeader: () => <Header />,
  renderSaveConfiguration: () => <SaveConfiguration />,
  renderLoadConfiguration: () => <LoadConfiguration />,
  renderSendEmail: () => <SendEmail />,
  renderPdfDownload: () => <PdfDownload />,
  renderAddToCart: () => <AddToCart />,
  Layout: DefaultLayout,
};
